import { formatDate } from '../utils/date';

export const hasValidCoordinates = (item = {}) => {
  if (item.lat == null || item.lng == null || item.lat === '' || item.lng === '') {
    return false;
  }

  const lat = Number(item.lat);
  const lng = Number(item.lng);

  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
};

export const coordinatesFor = (item) => [Number(item.lng), Number(item.lat)];

export const formatTravelogueLocation = (report = {}) => (
  [report.location_name, report.city, report.country].filter(Boolean).join(', ')
);

export const createTravelogueMarkerElement = (report = {}) => {
  const marker = document.createElement('button');
  marker.type = 'button';
  marker.className = 'travelogue-marker';
  marker.setAttribute(
    'aria-label',
    `Open travelogue: ${report.title || report.location_name || 'Travelogue visit'}`
  );

  const pin = document.createElement('span');
  pin.className = 'travelogue-marker__pin';
  pin.setAttribute('aria-hidden', 'true');
  marker.appendChild(pin);

  return marker;
};

export const createTraveloguePopupContent = (report = {}) => {
  const popup = document.createElement('article');
  popup.className = 'travelogue-popup';

  if (report.featured_image_url) {
    const image = document.createElement('img');
    image.className = 'travelogue-popup__image';
    image.src = report.featured_image_url;
    image.alt = '';
    image.loading = 'lazy';
    popup.appendChild(image);
  }

  const title = document.createElement('h3');
  title.textContent = report.title || 'Travelogue visit';
  popup.appendChild(title);

  const location = formatTravelogueLocation(report);
  if (location) {
    const locationText = document.createElement('p');
    locationText.className = 'travelogue-popup__location';
    locationText.textContent = location;
    popup.appendChild(locationText);
  }

  if (report.visit_date) {
    const visitDate = document.createElement('time');
    visitDate.className = 'travelogue-popup__date';
    visitDate.dateTime = report.visit_date;
    visitDate.textContent = `Visited ${formatDate(report.visit_date)}`;
    popup.appendChild(visitDate);
  }

  if (report.slug) {
    const link = document.createElement('a');
    link.className = 'travelogue-popup__link';
    link.href = `/travelogue/${encodeURIComponent(report.slug)}`;
    link.textContent = 'Read the travelogue';
    popup.appendChild(link);
  }

  return popup;
};
